/**
 * @generated SignedSource<<75ce8f9dbf7757581cbfa23b941afd7d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CommentsModeEnum = "qa" | "standard" | "%future added value";
export type PostStatusEnum = "acfDisabled" | "archived" | "autoDraft" | "dpRewriteRepublish" | "draft" | "future" | "inherit" | "pending" | "private" | "publish" | "requestCompleted" | "requestConfirmed" | "requestFailed" | "requestPending" | "trash" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SearchTagsContainer_feedContentResource$data = {
  readonly authors?: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly chorusId: number | null;
  readonly chorusUuid: string | null;
  readonly comments: {
    readonly enabled: boolean;
    readonly mode: CommentsModeEnum;
  };
  readonly globalId: string;
  readonly id: string;
  readonly primaryCategory?: {
    readonly title: string;
  };
  readonly status: PostStatusEnum;
  readonly " $fragmentType": "SearchTagsContainer_feedContentResource";
};
export type SearchTagsContainer_feedContentResource$key = {
  readonly " $data"?: SearchTagsContainer_feedContentResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"SearchTagsContainer_feedContentResource">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchTagsContainer_feedContentResource",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chorusId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chorusUuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentsType",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "globalId",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CategoryResourceType",
          "kind": "LinkedField",
          "name": "primaryCategory",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorProfileResourceType",
          "kind": "LinkedField",
          "name": "authors",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "FeedContentResourceInterface",
      "abstractKey": "__isFeedContentResourceInterface"
    }
  ],
  "type": "ContentResourceInterface",
  "abstractKey": "__isContentResourceInterface"
};
})();

(node as any).hash = "41d7663e491f15a2f8851e239954632c";

export default node;
